import * as React from "react";

type DeltaBadgeProps = {
    amount: number
    previousAmount: number
    /** Label shown when there is no reference amount (a new entry); omit to render nothing in that case. */
    newLabel?: string
};

/**
 * A small coloured indicator of the relative change between an amount and a reference amount
 * (green for growth, red for decline). Reusable wherever a change vs. a baseline is shown.
 */
const DeltaBadge: React.FC<DeltaBadgeProps> = ({amount, previousAmount, newLabel}) => {
    if (previousAmount === 0) {
        return amount > 0 && newLabel ? <span className="text-xs text-green-600 whitespace-nowrap">{newLabel}</span> : null;
    }
    const percent = Math.round((amount - previousAmount) / previousAmount * 1000) / 10;
    if (percent === 0) {
        return <span className="text-xs text-gray-400 whitespace-nowrap">±0 %</span>;
    }
    return (
        <span className={`text-xs whitespace-nowrap ${percent > 0 ? 'text-green-600' : 'text-red-600'}`}>
            {percent > 0 ? '+' : ''}{percent} %
        </span>
    );
};

export default DeltaBadge;
